<template>
		<div>
		<section class="section-results page-content py-5">
			<div class="container">
				<div class="row no-gutters justify-content-between">
					<div class="col-8">
						<header class="page-header">
							<h1 class="color-green mb-4">Results</h1>
						</header>

						<div class="content-block">
							<h6>Your estimated annual utility costs:</h6>
							<p></p>

							<h2 class="color-green mb-4">${{out.utilityCost}}</h2>

							<p>This is how much we've estimated for your utility costs. If a unitary electric resistance water heating system were used,
								your utility cost would have been <span style="color: red;">${{out.inUnitUtilityCost}}</span>. 
								Thus, you save <span style="color: green;">${{out.savings}}</span> annually.
							</p>

							<PlotlyPlot v-if="plotSim" :data="plotSim.data" :layout="plotSim.layout" />

						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import PlotlyPlot from '@/components/PlotlyPlot'
import sizerStore from '@/components/Sizer/sizer-store'

export default {
	name: 'UtilityCalcResults',

	components: {
		PlotlyPlot,
	},

	computed: {
		out () {
			return sizerStore.out
		},
		
		plotSim () {
			const { plotSimDiv } = sizerStore

			return plotSimDiv && JSON.parse(plotSimDiv)
		},
	}
}
</script>

<style type="text/css"></style>
